import React from 'react';
import {Button} from "../../components/atoms/Button";

function OnboardingButtons({goNextStep, goBackStep, nextDisabled, backHidden, finish}) {


    const today = new Date()

    return (
        <div className='flex flex-col gap-3'>
            <Button variant={'default'} disabled={nextDisabled} onClick={goNextStep}>
                {finish ? 'Finish' : 'Continue'}
            </Button>
            {!backHidden &&
                <Button variant={'ghost'} onClick={goBackStep}>
                    Go Back
                </Button>
            }
        </div>
    );
}

export default OnboardingButtons;
